/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedDeposit_item$ref = any;
export type PdpSharedDeposit_item = {
    readonly serviceId: string | null;
    readonly isDepositAvailable: boolean;
    readonly " $refType": PdpSharedDeposit_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDeposit_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isDepositAvailable",
            "args": [
                {
                    "kind": "Variable",
                    "name": "buyerId",
                    "variableName": "userId"
                }
            ],
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '51959073e97db7635d60956c8fb243f6';
export default node;
